import makeStyles from '@mui/styles/makeStyles'

const checked = {
  backgroundColor: '#3D84CC',
  color: '#fff'
}

export const useStyles = makeStyles(({ spacing }) => ({
  root: {},
  departmentList: {
    '& > h6': {
      cursor: 'pointer',
      marginBottom: spacing(2),
      height: 28,
      padding: spacing(0.5, 1),
      borderRadius: '4px 100px 100px 4px',
      '&:hover': { ...checked }
    }
  },
  checked
}))
